import { CSSProperties, FC, ReactNode } from 'react';
import { Divider, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { FinancialOverviewSectionHeader } from '@/shared/components/financial-overview';

export interface SettingsCalloutCardProps {
    action?: ReactNode;
    children?: ReactNode;
    description: ReactNode;
    icon?: ReactNode;
    style?: CSSProperties;
    title: ReactNode;
}

const SettingsCalloutCard: FC<SettingsCalloutCardProps> = ({ action, children, description, icon, style, title }) => {
    const { token } = useAntDesignTheme();
    const footer = action ?? children;

    return (
        <div
            style={{
                background: token.colorBgBase,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: token.borderRadius * 1.5,
                padding: '1.125rem',
                ...style,
            }}
        >
            {icon ? (
                <FinancialOverviewSectionHeader description={description} icon={icon} title={title} />
            ) : (
                <>
                    <div style={{ marginBottom: '0.5rem' }}>
                        <Typography.Text strong>{title}</Typography.Text>
                    </div>
                    <Typography.Text type='secondary'>{description}</Typography.Text>
                </>
            )}
            {footer ? (
                <>
                    <Divider style={{ margin: '1rem 0' }} />
                    {footer}
                </>
            ) : null}
        </div>
    );
};

export default SettingsCalloutCard;
